<script>
export default {
    name: "vue-alert",

    data() {
        return {
            visible: true
        }
    },

    props: {
        type: {
            type: String,
            default: 'info',
            validator(val) {
                return [
                    'success',
                    'danger',
                    'warning',
                    'info'
                ].indexOf(val) !== -1;
            }
        },
        
        message: {
            type: String,
            default: null
        },

        closable: {
            type: Boolean,
            default: false
        },

        flush: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        classes() {
            return [
                `alert-${this.type}`,
                {
                    alert: true,
                    fade: false,
                    show: true,
                    'vue-alert-flush': this.flush === true,
                }
            ];
        }
    },

    methods: {
        close() {
            this.visible = false;
            this.$emit('close');
        },
    }
};
</script>


<template>
    <div v-if="visible" :class="classes">
        <span v-if="closable" class="close" @click="close">×</span>
        <slot>
            <p>{{ message }}</p>
        </slot>
    </div>
</template>
